import React from 'react';
import { TextInput, ReferenceInput, AutocompleteInput, SelectInput } from 'react-admin';

import Edit from '../common/views/Edit';
import SimpleForm from '../common/forms/SimpleForm';
import CountryInput from '../common/inputs/CountryInput';

const optionText = choice => choice.name ? choice.name : '';

const deliveryMethodChoices = [
    { id: 'email', name: 'Email only' },
    { id: 'peppol', name: 'PEPPOL only' },
    { id: 'both', name: 'Email and PEPPOL' },
];

const AddressEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="id" disabled />
            <ReferenceInput label="Customer" source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }} allowEmpty>
                <AutocompleteInput optionText={optionText} />
            </ReferenceInput>
            <TextInput source="name" />
            <TextInput source="vat_number" />
            <TextInput source="street" />
            <TextInput source="street_bis" />
            <TextInput source="number" />
            <TextInput source="box" />
            <TextInput source="zipcode" />
            <TextInput source="city" />
            <CountryInput source="country" />
            <TextInput source="email" />
            <TextInput source="phone" />
            <SelectInput source="invoice_delivery_method" label="Invoice Delivery" choices={deliveryMethodChoices} defaultValue="both" />
        </SimpleForm>
    </Edit>
);

export default AddressEdit;